export const getBookEnds = (length: number) => (target: string) =>
    target.replace(RegExp(`(.{${length}}).*(.{${length}})`), "$1$2");
